import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const teacherDesignationsApi = {
  getAll: () =>
    api.get<ApiResponse<any[]>>('/teacher-designations'),

  getActive: () =>
    api.get<ApiResponse<any[]>>('/teacher-designations/active'),

  getById: (id: number) =>
    api.get<ApiResponse<any>>(`/teacher-designations/${id}`),

  create: (data: { name: string, is_active?: boolean }) =>
    api.post<ApiResponse<any>>('/teacher-designations', data),

  update: (id: number, data: { name: string, is_active?: boolean }) =>
    api.put<ApiResponse<any>>(`/teacher-designations/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/teacher-designations/${id}`),

  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/teacher-designations/${id}/permanent`),
}

